module.exports = __webpack_public_path__ + "img/KitchenDining01.65a2f58e.png";